
import { HeroSection } from "./HeroSection";
import { SocialProofSection } from "./SocialProofSection";
import { HowItWorksSection } from "./HowItWorksSection";
import { TestimonialsSection } from "./TestimonialsSection";
import { PEOComparisonLeadMagnet } from "./PEOComparisonLeadMagnet";
import { EnhancedFAQs } from "../seo/EnhancedFAQs";
import { CtaSection } from "./CtaSection";
import { MainNavigation } from "../layout/MainNavigation";
import { Footer } from "../layout/Footer";

export const EnhancedLandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />
      <main className="pt-16">
        <HeroSection />
        <HowItWorksSection />
        <SocialProofSection />
        <TestimonialsSection />
        <PEOComparisonLeadMagnet />
        <EnhancedFAQs showSchema={true} />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};
